import type { IModalSlice } from './slice'
import { MODAL_SLICE_KEY } from './slice'

/**
 *
 */
export function createModalSelectors<Configs>() {
  return {
    modalActionsSelector: (state: IModalSlice<Configs>) => {
      return state[MODAL_SLICE_KEY].actions
    },

    openedModalsSelector: (state: IModalSlice<Configs>) => {
      return state[MODAL_SLICE_KEY].openedModals
    },

    hasModalOpenedSelector: (state: IModalSlice<Configs>, modalKey: string) => {
      return !!state[MODAL_SLICE_KEY].openedModals.find(
        (o) => o.id === modalKey,
      )
    },
  }
}
